import { style, animate, trigger } from '@angular/animations';

const ShakeAnimation = [
  style({ transform: 'rotate(0)' }),
  animate('0.4s', style({ transform: 'translateX(16px)' })),
  animate('0.6s', style({ transform: 'translateX(16px)' })),
  animate('0.3s', style({ transform: 'translateX(8px)' })),
  animate('0.3s', style({ transform: 'translateX(8px)' })),
  animate('0.2s', style({ transform: 'translateX(3px)' })),
  animate('0.1s', style({ transform: 'translateX(0)' }))
];
